import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import CacheBuster from './CacheBuster';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';
import './i18next/i18next';
import { initI18n } from './i18next/i18next';
import { store } from 'state/store';
import { Provider } from 'react-redux';

const start = async () => {
    await initI18n();

    const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
    );

    root.render(
        <Provider store={store}>
            <BrowserRouter>
                <CacheBuster>
                    <App />
                </CacheBuster>
            </BrowserRouter>
        </Provider>
    );
};

start();
